module.exports = __webpack_public_path__ + "static/media/illo_collaboration.baae727d.svg";